import {
  EntityDropdownInputBare,
  type EntityDropdownInputBareProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInputBare";
import { FormCategoryAdapter } from "@validereinc/domain";
import React from "react";

/**
 * Uncontrolled Form Category dropdown using DropdownInputBare for use in FilterBuilder.
 * Value is controlled by parent (e.g. filter state); does not register with react-hook-form.
 */
export const FormCategoryDropdownInputBare = (
  props: Omit<EntityDropdownInputBareProps<unknown>, "fetchEntityList">
) => {
  return (
    <EntityDropdownInputBare
      fetchEntityList={FormCategoryAdapter.getList}
      label={props.label ?? "Form Category"}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
